import type { GetOpenAragCaseRequests } from '@cloudFunctions/types/arag/getOpenAragCaseRequests';
import type { SignIntoArag } from '@cloudFunctions/types/arag/signIntoArag';
import type { SignOutOfArag } from '@cloudFunctions/types/arag/signOutOfArag';
import type { GetAragCaseByCaseAssistNumber } from '@cloudFunctions/types/arag/getAragCaseByCaseAssistNumber';
import type { GetAragCasesByMemberId } from '@cloudFunctions/types/arag/getAragCasesByMemberId';
import type {
  AcceptAragCaseRequestData,
  AcceptAragCaseResult,
  AcceptAragCaseSuccessPayload,
} from '@cloudFunctions/types/arag/acceptAragCase';
import type {
  GetAllAragCasesForAttorneyRequestData,
  GetAllAragCasesForAttorneyResult,
} from '@cloudFunctions/types/arag/getAllAragCasesForAttorney';
import type { CaseDetailsPage } from '@cloudFunctions/types/arag/caseDetailsPage';
import { invokeBackendRoute } from '@/backend/invoke';

export type {
  SignIntoArag,
  GetOpenAragCaseRequests,
  SignOutOfArag,
  GetAragCaseByCaseAssistNumber,
  GetAragCasesByMemberId,
  AcceptAragCaseRequestData,
  AcceptAragCaseResult,
  AcceptAragCaseSuccessPayload,
  CaseDetailsPage,
};

export const getOpenAragCaseRequests = async (
  props: GetOpenAragCaseRequests.Props,
) =>
  invokeBackendRoute<
    GetOpenAragCaseRequests.Result,
    GetOpenAragCaseRequests.Props
  >('getOpenAragCaseRequests', props);

export const getAllAragCasesForAttorney = async (
  requestData: GetAllAragCasesForAttorneyRequestData,
) =>
  invokeBackendRoute<
    GetAllAragCasesForAttorneyResult,
    GetAllAragCasesForAttorneyRequestData
  >('getAllAragCasesForAttorney', requestData);

export const signIntoArag = async (props: SignIntoArag.Props) =>
  invokeBackendRoute<SignIntoArag.Result, SignIntoArag.Props>(
    'signIntoArag',
    props,
  );

export const signOutOfArag = async (props: SignOutOfArag.Props) =>
  invokeBackendRoute<SignOutOfArag.Result, SignOutOfArag.Props>(
    'signOutOfArag',
    props,
  );

export const getAragCaseByCaseAssistNumber = async (
  props: GetAragCaseByCaseAssistNumber.RequestData,
) =>
  invokeBackendRoute<
    GetAragCaseByCaseAssistNumber.Result,
    GetAragCaseByCaseAssistNumber.RequestData
  >('getAragCaseByCaseAssistNumber', props);

export const getAragCasesByMemberId = async (
  props: GetAragCasesByMemberId.RequestData,
) =>
  invokeBackendRoute<
    GetAragCasesByMemberId.Result,
    GetAragCasesByMemberId.RequestData
  >('getAragCasesByMemberId', props);

export const acceptAragCase = async (props: AcceptAragCaseRequestData) =>
  invokeBackendRoute<AcceptAragCaseResult, AcceptAragCaseRequestData>(
    'acceptAragCase',
    props,
  );
